import { proxy } from 'valtio';
import { DomainContextProvider } from './context';
export const DomainContext = proxy(new DomainContextProvider());
